import { Component, Prop, h } from '@stencil/core';
import { ReviewImageType } from '@ugc-components/ugc-pdp-review/interface';
import state from '@ugc-store';
import { getArray } from '@ugc-utils/utils';

@Component({
  tag: 'ugc-review-content-images',
  shadow: false,
})
export class UgcReviewContentImages {
  @Prop() data: any = {};
  @Prop() type: ReviewImageType = ReviewImageType.InReviewList;

  async handleImageClick(index) {
    if (this.type === ReviewImageType.InPendingReview) return;

    try {
      state.isShowReviewImageModal = true;
      state.reviewImageModalData = JSON.parse(
        JSON.stringify({
          reviewItem: this.data,
          imageActiveIndex: index,
        })
      );
    } catch (e) {}
  }

  render() {
    const images = getArray(this.data && this.data.images);

    const renderReviewImages = images.map(
      (item, index) =>
        item.paths &&
        item.paths.s && (
          <div
            key={item.assetId}
            class={`ugc-overflow-hidden mb-8 rounded-4 ${
              this.type === ReviewImageType.InPendingReview ? '' : 'pointer'
            }`}
            style={{ flex: `0 0 105px`, height: '105px' }}
            onClick={() => this.handleImageClick(index)}
          >
            <img src={item.paths.s} alt="" style={{ width: '100%' }} />
          </div>
        )
    );

    return images.length > 0 && <div class="flex-row-start-center mb-16 flex-wrap gap-4">{renderReviewImages}</div>;
  }
}
